const OntarioGrade9Image = "/assets/grades/ON/1.png";
const OntarioGrade10Image = "/assets/grades/ON/2.png";
const OntarioGrade11Image = "/assets/grades/ON/3.png";
const OntarioGrade12Image = "/assets/grades/ON/4.png";
const AlbertaGrade9Image = "/assets/grades/AB/AB9.png";
const AlbertaGrade10Image = "/assets/grades/AB/AB10.png";
const AlbertaGrade11Image = "/assets/grades/AB/AB11.png";
const AlbertaGrade12Image = "/assets/grades/AB/AB12.png";
const BCGrade9Image = "/assets/grades/BC/BC9.png";
const BCGrade10Image = "/assets/grades/BC/BC10.png";
const BCGrade11Image = "/assets/grades/BC/BC11.png";
const BCGrade12Image = "/assets/grades/BC/BC12.png";
const QuebecSecondary3Image = "/assets/grades/QC/1.png";
const QuebecSecondary4Image = "/assets/grades/QC/2.png";
const QuebecSecondary5Image = "/assets/grades/QC/3.png";

const AlbertaGroupImage = "/assets/grades/CZ/ABCareerZone.jpg";
const BritishColumbiaGroupImage = "/assets/grades/CZ/BCCareerZone.jpg";
const QuebecGroupImage = "/assets/grades/CZ/QCCareerZone.jpg";
const OntarioGroupImage = "/assets/grades/CZ/ONCareerZone.jpg";
const ManitobaGroupImage = "/assets/grades/CZ/Manitoba.jpeg";
const NovaScotiaGroupImage = "/assets/grades/CZ/NovaScotia.jpeg";
const SaskatchewanGroupImage = "/assets/grades/CZ/Saskatchewan.jpeg";
const NclexRnGroupImage = "/assets/exams/nclex-rn.jpeg";
const RexPnGroupImage = "/assets/exams/rex-pn.jpeg";
const PEBCGroupImage = "/assets/exams/pebe.jpeg";

const OntarioGrade9Subjects = [
  {
    label: "Grade 9 Science ON",
    courseCode: "SNC1W (De-streamed, 2022 curriculum)",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Sustainable Ecosystems",
        chapters: [
          { text: "Chapter 1: Nutrient Cycles" },
          { text: "Chapter 2: Human Impact on Ecosystems" },
        ],
      },
      {
        text: "Unit B: Atoms & Elements",
        chapters: [
          { text: "Chapter 3: Periodic Table" },
          { text: "Chapter 4: Chemical Properties" },
        ],
      },
      {
        text: "Unit C: Electricity",
        chapters: [
          { text: "Chapter 5: Static and Current Electricity" },
          { text: "Chapter 6: Circuit Design" },
        ],
      },
      {
        text: "Unit D: Space Exploration",
        chapters: [
          { text: "Chapter 7: Solar System" },
          { text: "Chapter 8: Satellite Technology" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Mathematics ON",
    courseCode: "MTH1W (De-streamed)",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Number Sense",
        chapters: [
          { text: "Chapter 1: Rational Numbers" },
          { text: "Chapter 2: Powers and Exponents" },
        ],
      },
      {
        text: "Unit B: Algebra",
        chapters: [
          { text: "Chapter 3: Polynomial Expressions" },
          { text: "Chapter 4: Linear Equations" },
        ],
      },
      {
        text: "Unit C: Data Literacy",
        chapters: [
          { text: "Chapter 5: Statistical Analysis" },
          { text: "Chapter 6: Data Visualization" },
        ],
      },
      {
        text: "Unit D: Financial Literacy",
        chapters: [
          { text: "Chapter 7: Budgeting" },
          { text: "Chapter 8: Interest Calculations" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 English ON",
    courseCode: "ENG1D (Academic) / ENG1P (Applied)",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Literary Studies",
        chapters: [
          { text: "Chapter 1: Novel Study (e.g., The Giver)" },
          { text: "Chapter 2: Shakespeare (e.g., A Midsummer Night's Dream)" },
        ],
      },
      {
        text: "Unit B: Writing",
        chapters: [
          { text: "Chapter 3: Essay Structure" },
          { text: "Chapter 4: Narrative Writing" },
        ],
      },
      {
        text: "Unit C: Media Studies",
        chapters: [
          { text: "Chapter 5: Advertising Analysis" },
          { text: "Chapter 6: Digital Media Creation" },
        ],
      },
      {
        text: "Unit D: Oral Communication",
        chapters: [
          { text: "Chapter 7: Debates" },
          { text: "Chapter 8: Presentations" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 French ON",
    courseCode: "FSF1D (Academic) / FSF1P (Applied)",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Communication",
        chapters: [
          { text: "Chapter 1: Daily Routines" },
          { text: "Chapter 2: Leisure Activities" },
        ],
      },
      {
        text: "Unit B: Grammar",
        chapters: [
          { text: "Chapter 3: Present Tense Verbs" },
          { text: "Chapter 4: Adjective Agreement" },
        ],
      },
      {
        text: "Unit C: Culture",
        chapters: [
          { text: "Chapter 5: Francophone Communities" },
          { text: "Chapter 6: French Festivals" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Geography ON",
    courseCode: "CGC1D (Academic) / CGC1P (Applied)",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Canadian Geography",
        chapters: [
          { text: "Chapter 1: Physical Regions" },
          { text: "Chapter 2: Natural Resources" },
        ],
      },
      {
        text: "Unit B: Environmental Issues",
        chapters: [
          { text: "Chapter 3: Climate Change" },
          { text: "Chapter 4: Sustainable Development" },
        ],
      },
      {
        text: "Unit C: Human Geography",
        chapters: [
          { text: "Chapter 5: Population Distribution" },
          { text: "Chapter 6: Urbanization" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Healthy Active Living ON",
    courseCode: "PPL1O",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Fitness",
        chapters: [
          { text: "Chapter 1: Training Principles" },
          { text: "Chapter 2: Personal Fitness Plans" },
        ],
      },
      {
        text: "Unit B: Sports",
        chapters: [
          { text: "Chapter 3: Volleyball/Basketball Skills" },
          { text: "Chapter 4: Cooperative Games" },
        ],
      },
      {
        text: "Unit C: Health",
        chapters: [
          { text: "Chapter 5: Mental Health Awareness" },
          { text: "Chapter 6: Substance Use Education" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Learning Strategies ON",
    courseCode: "GLS1O",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Study Skills",
        chapters: [
          { text: "Chapter 1: Note-Taking Methods" },
          { text: "Chapter 2: Test Preparation" },
        ],
      },
      {
        text: "Unit B: Organization",
        chapters: [
          { text: "Chapter 3: Time Management" },
          { text: "Chapter 4: Goal Setting" },
        ],
      },
      {
        text: "Unit C: Research Skills",
        chapters: [
          { text: "Chapter 5: Source Evaluation" },
          { text: "Chapter 6: Citation Methods" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Technological Education ON",
    courseCode: "TIJ1O",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Modules",
        chapters: [
          { text: "Chapter 1: Construction Technology" },
          { text: "Chapter 2: Computer Engineering" },
          { text: "Chapter 3: Hospitality (Foods)" },
          { text: "Chapter 4: Hairstyling & Aesthetics" },
          { text: "Chapter 5: Manufacturing" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Arts ON",
    courseCode: "AVI1O (Visual Arts) / AMU1O (Music)",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Visual Arts",
        chapters: [
          { text: "Chapter 1: Drawing Techniques" },
          { text: "Chapter 2: Sculpture" },
        ],
      },
      {
        text: "Unit B: Music",
        chapters: [
          { text: "Chapter 3: Instrumental Performance" },
          { text: "Chapter 4: Composition" },
        ],
      },
      {
        text: "Unit C: Drama",
        chapters: [
          { text: "Chapter 5: Improvisation" },
          { text: "Chapter 6: Scene Study" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 First Nations ON",
    courseCode: "NAC1O",
    image: OntarioGrade9Image,
    units: [
      {
        text: "Unit A: Indigenous Histories",
        chapters: [
          { text: "Chapter 1: Pre-Contact Societies" },
          { text: "Chapter 2: Treaty Relationships" },
        ],
      },
      {
        text: "Unit B: Contemporary Issues",
        chapters: [
          { text: "Chapter 3: Residential Schools" },
          { text: "Chapter 4: Land Claims" },
        ],
      },
      {
        text: "Unit C: Cultural Practices",
        chapters: [
          { text: "Chapter 5: Oral Traditions" },
          { text: "Chapter 6: Art Forms" },
        ],
      },
    ],
  },
];

const OntarioGrade10Subjects = [
  {
    label: "Grade 10 Science ON",
    courseCode: "SNC2D (Academic) / SNC2P (Applied)",
    image: OntarioGrade10Image,
    units: [
      {
        text: "Unit A: Biology - Tissues & Organs",
        chapters: [
          { text: "Chapter 1: Organ Systems (e.g., Digestive, Circulatory)" },
          { text: "Chapter 2: Plant Anatomy" },
        ],
      },
      {
        text: "Unit B: Chemistry - Chemical Reactions",
        chapters: [
          { text: "Chapter 3: Acid-Base Reactions" },
          { text: "Chapter 4: Conservation of Mass" },
        ],
      },
      {
        text: "Unit C: Physics - Light & Optics",
        chapters: [
          { text: "Chapter 5: Reflection/Refraction" },
          { text: "Chapter 6: Lens Equations" },
        ],
      },
      {
        text: "Unit D: Climate Change",
        chapters: [
          { text: "Chapter 7: Carbon Cycle" },
          { text: "Chapter 8: Mitigation Strategies" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Mathematics ON",
    courseCode: "MPM2D (Academic) / MFM2P (Applied)",
    image: OntarioGrade10Image,
    units: [
      {
        text: "Unit A: Academic - MPM2D",
        chapters: [
          { text: "Chapter 1: Quadratic Relations" },
          { text: "Chapter 2: Analytic Geometry" },
          { text: "Chapter 3: Trigonometry" },
        ],
      },
      {
        text: "Unit B: Applied - MFM2P",
        chapters: [
          { text: "Chapter 4: Similar Triangles" },
          { text: "Chapter 5: Measurement Applications" },
          { text: "Chapter 6: Budgeting Projects" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 English ON",
    courseCode: "ENG2D (Academic) / ENG2P (Applied)",
    image: OntarioGrade10Image,
    units: [
      {
        text: "Unit A: Literature Study",
        chapters: [
          { text: "Chapter 1: Novel (e.g., To Kill a Mockingbird)" },
          { text: "Chapter 2: Shakespeare (Macbeth)" },
        ],
      },
      {
        text: "Unit B: Writing Portfolio",
        chapters: [
          { text: "Chapter 3: Literary Essays" },
          { text: "Chapter 4: Creative Narratives" },
        ],
      },
      {
        text: "Unit C: Media Analysis",
        chapters: [
          { text: "Chapter 5: Film Adaptations" },
          { text: "Chapter 6: Social Media Literacy" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Canadian History ON",
    courseCode: "CHC2D (Academic) / CHC2P (Applied)",
    image: OntarioGrade10Image,
    units: [
      {
        text: "Unit A: 1914-1929",
        chapters: [
          { text: "Chapter 1: WWI & Halifax Explosion" },
          { text: "Chapter 2: Women's Suffrage" },
        ],
      },
      {
        text: "Unit B: 1929-1945",
        chapters: [
          { text: "Chapter 3: Great Depression" },
          { text: "Chapter 4: WWII Internment Camps" },
        ],
      },
      {
        text: "Unit C: 1945-1982",
        chapters: [
          { text: "Chapter 5: Cold War" },
          { text: "Chapter 6: Charter of Rights" },
        ],
      },
      {
        text: "Unit D: 1982-Present",
        chapters: [
          { text: "Chapter 7: Indigenous Reconciliation" },
          { text: "Chapter 8: Globalization" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Career Studies ON",
    courseCode: "GLC2O (Compulsory Half-Credit)",
    image: OntarioGrade10Image,
    units: [
      {
        text: "Unit A: Career Exploration",
        chapters: [
          { text: "Chapter 1: Skills Assessment" },
          { text: "Chapter 2: Job Market Trends" },
        ],
      },
      {
        text: "Unit B: Financial Planning",
        chapters: [
          { text: "Chapter 3: Budget Simulations" },
          { text: "Chapter 4: Post-Secondary Costs" },
        ],
      },
      {
        text: "Unit C: Digital Citizenship",
        chapters: [
          { text: "Chapter 5: Online Professionalism" },
          { text: "Chapter 6: Digital Footprint" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Civics ON",
    courseCode: "CHV2O (Compulsory Half-Credit)",
    image: OntarioGrade10Image,
    units: [
      {
        text: "Unit A: Government Structure",
        chapters: [
          { text: "Chapter 1: Federal/Provincial Roles" },
          { text: "Chapter 2: Electoral Process" },
        ],
      },
      {
        text: "Unit B: Social Justice",
        chapters: [
          { text: "Chapter 3: Equity vs. Equality" },
          { text: "Chapter 4: Advocacy Case Studies" },
        ],
      },
      {
        text: "Unit C: Community Engagement",
        chapters: [
          { text: "Chapter 5: Service Learning" },
          { text: "Chapter 6: Mock Elections" },
        ],
      },
    ],
  },
];

const OntarioGrade11Subjects = [
  {
    label: "Grade 11 Biology ON",
    courseCode: "SBI3U (University) / SBI3C (College)",
    image: OntarioGrade11Image,
    units: [
      {
        text: "Unit A: University - SBI3U",
        chapters: [
          { text: "Chapter 1: Genetic Processes" },
          { text: "Chapter 2: Animal Anatomy" },
          { text: "Chapter 3: Plant Biology" },
        ],
      },
      {
        text: "Unit B: College - SBI3C",
        chapters: [
          { text: "Chapter 4: Microbiology" },
          { text: "Chapter 5: Environmental Biology" },
          { text: "Chapter 6: Health Science Applications" },
        ],
      },
    ],
  },
  {
    label: "Grade 11 Functions ON",
    courseCode: "MCR3U (University Prep)",
    image: OntarioGrade11Image,
    units: [
      {
        text: "Unit A: Trigonometric Functions",
        chapters: [
          { text: "Chapter 1: Sine/Cosine Laws" },
          { text: "Chapter 2: Periodic Functions" },
        ],
      },
      {
        text: "Unit B: Exponential Functions",
        chapters: [
          { text: "Chapter 3: Growth/Decay Models" },
          { text: "Chapter 4: Compound Interest" },
        ],
      },
      {
        text: "Unit C: Discrete Functions",
        chapters: [
          { text: "Chapter 5: Sequences/Series" },
          { text: "Chapter 6: Financial Applications" },
        ],
      },
    ],
  },
  {
    label: "Grade 11 Chemistry ON",
    courseCode: "SCH3U (University) / SCH3C (College)",
    image: OntarioGrade11Image,
    units: [
      {
        text: "Unit A: University - SCH3U",
        chapters: [
          { text: "Chapter 1: Quantum Model" },
          { text: "Chapter 2: Stoichiometry" },
          { text: "Chapter 3: Gases/Liquids" },
        ],
      },
      {
        text: "Unit B: College - SCH3C",
        chapters: [
          { text: "Chapter 4: Matter Analysis" },
          { text: "Chapter 5: Chemical Reactions" },
          { text: "Chapter 6: Environmental Chemistry" },
        ],
      },
    ],
  },
  {
    label: "Grade 11 Introduction to Anthropology ON",
    courseCode: "HSP3U/C (University/College)",
    image: OntarioGrade11Image,
    units: [
      {
        text: "Unit A: Cultural Anthropology",
        chapters: [
          { text: "Chapter 1: Kinship Systems" },
          { text: "Chapter 2: Rites of Passage" },
        ],
      },
      {
        text: "Unit B: Archaeology",
        chapters: [
          { text: "Chapter 3: Dating Methods" },
          { text: "Chapter 4: Ontario Dig Sites" },
        ],
      },
      {
        text: "Unit C: Linguistics",
        chapters: [
          { text: "Chapter 5: Language Preservation" },
          { text: "Chapter 6: Indigenous Oral Traditions" },
        ],
      },
    ],
  },
];

const OntarioGrade12Subjects = [
  {
    label: "Grade 12 Advanced Functions ON",
    courseCode: "MHF4U (University Prep)",
    image: OntarioGrade12Image,
    note: "Prerequisite for Calculus & Vectors",
    units: [
      {
        text: "Unit A: Polynomial Functions",
        chapters: [
          { text: "Chapter 1: End Behavior" },
          { text: "Chapter 2: Inequalities" },
        ],
      },
      {
        text: "Unit B: Trigonometry",
        chapters: [
          { text: "Chapter 3: Identities" },
          { text: "Chapter 4: Compound Angles" },
        ],
      },
      {
        text: "Unit C: Logarithms",
        chapters: [
          { text: "Chapter 5: Laws of Logs" },
          { text: "Chapter 6: Exponential Modeling" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Biology ON",
    courseCode: "SBI4U (University Prep)",
    image: OntarioGrade12Image,
    units: [
      {
        text: "Unit A: Biochemistry",
        chapters: [
          { text: "Chapter 1: Metabolic Pathways" },
          { text: "Chapter 2: Enzyme Kinetics" },
        ],
      },
      {
        text: "Unit B: Molecular Genetics",
        chapters: [
          { text: "Chapter 3: DNA Replication" },
          { text: "Chapter 4: Biotechnology" },
        ],
      },
      {
        text: "Unit C: Homeostasis",
        chapters: [
          { text: "Chapter 5: Nervous/Endocrine Systems" },
          { text: "Chapter 6: Feedback Mechanisms" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Data Management ON",
    courseCode: "MDM4U (University Prep)",
    image: OntarioGrade12Image,
    units: [
      {
        text: "Unit A: Probability",
        chapters: [
          { text: "Chapter 1: Counting Principles" },
          { text: "Chapter 2: Probability Distributions" },
        ],
      },
      {
        text: "Unit B: Statistical Analysis",
        chapters: [
          { text: "Chapter 3: Hypothesis Testing" },
          { text: "Chapter 4: Regression Models" },
        ],
      },
      {
        text: "Unit C: Data Visualization",
        chapters: [
          { text: "Chapter 5: Infographic Design" },
          { text: "Chapter 6: Big Data Ethics" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Canadian & World Issues ON",
    courseCode: "CGW4U (University Prep)",
    image: OntarioGrade12Image,
    units: [
      {
        text: "Unit A: Global Systems",
        chapters: [
          { text: "Chapter 1: Climate Change Accords" },
          { text: "Chapter 2: UN Sustainable Goals" },
        ],
      },
      {
        text: "Unit B: Geopolitics",
        chapters: [
          { text: "Chapter 3: Resource Conflicts" },
          { text: "Chapter 4: Migration Patterns" },
        ],
      },
      {
        text: "Unit C: Case Studies",
        chapters: [
          { text: "Chapter 5: Arctic Sovereignty" },
          { text: "Chapter 6: Water Security" },
        ],
      },
    ],
  },
];

const AlbertaGrade9Subjects = [
  {
    label: "Grade 9 Science AB",
    courseCode: "SCI 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Unit A: Biological Diversity",
        chapters: [
          { text: "Chapter 1: Understanding Biodiversity" },
          { text: "Chapter 2: Variation and Species Survival" },
          { text: "Chapter 3: Human Impacts on Ecosystems" },
        ],
      },
      {
        text: "Unit B: Matter and Chemical Change",
        chapters: [
          { text: "Chapter 4: Atomic Theory and Elements" },
          { text: "Chapter 5: Chemical Reactions and Equations" },
          { text: "Chapter 6: Environmental Chemistry Connections" },
        ],
      },
      {
        text: "Unit C: Electrical Principles and Technologies",
        chapters: [
          { text: "Chapter 7: Static and Current Electricity" },
          { text: "Chapter 8: Series and Parallel Circuits" },
          { text: "Chapter 9: Renewable Energy Technologies" },
        ],
      },
      {
        text: "Unit D: Space Exploration",
        chapters: [
          { text: "Chapter 10: Our Solar System and Beyond" },
          { text: "Chapter 11: Space Technology and Exploration" },
          { text: "Chapter 12: Ethics and Future of Space Travel" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Mathematics AB",
    courseCode: "MATH 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Unit 1: Number Sense",
        chapters: [
          { text: "Chapter 1: Rational Numbers and Square Roots" },
          { text: "Chapter 2: Powers and Exponent Laws" },
        ],
      },
      {
        text: "Unit 2: Algebra",
        chapters: [
          { text: "Chapter 3: Polynomials and Equations" },
          { text: "Chapter 4: Linear Relations and Graphing" },
        ],
      },
      {
        text: "Unit 3: Geometry",
        chapters: [
          { text: "Chapter 5: Circle Geometry and Constructions" },
          { text: "Chapter 6: Surface Area and Volume" },
        ],
      },
      {
        text: "Unit 4: Data Analysis",
        chapters: [
          { text: "Chapter 7: Probability and Statistics" },
          { text: "Chapter 8: Interpreting Graphs" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 English Language Arts AB",
    courseCode: "ELA 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Unit 1: Reading for Meaning",
        chapters: [
          { text: "Chapter 1: Short Stories and Novels" },
          { text: "Chapter 2: Poetry and Non-Fiction Analysis" },
        ],
      },
      {
        text: "Unit 2: Writing and Composition",
        chapters: [
          { text: "Chapter 3: Narrative and Persuasive Writing" },
          { text: "Chapter 4: Research and Report Writing" },
        ],
      },
      {
        text: "Unit 3: Media and Oral Communication",
        chapters: [
          { text: "Chapter 5: Digital Media Literacy" },
          { text: "Chapter 6: Debates and Presentations" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Social Studies AB",
    courseCode: "SOC 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Unit 1: Canadian Identity",
        chapters: [
          { text: "Chapter 1: Immigration and Multiculturalism" },
          { text: "Chapter 2: Charter of Rights and Freedoms" },
        ],
      },
      {
        text: "Unit 2: Governance and Economics",
        chapters: [
          { text: "Chapter 3: Political Systems and Democracy" },
          { text: "Chapter 4: Market vs. Mixed Economies" },
        ],
      },
      {
        text: "Unit 3: Indigenous Perspectives",
        chapters: [
          { text: "Chapter 5: Treaty Relationships" },
          { text: "Chapter 6: Residential Schools and Reconciliation" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Physical Education AB",
    courseCode: "PE 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Module 1: Active Living",
        chapters: [
          { text: "Chapter 1: Fitness Training and Goal Setting" },
          { text: "Chapter 2: Yoga and Movement Skills" },
        ],
      },
      {
        text: "Module 2: Sports and Games",
        chapters: [
          { text: "Chapter 3: Team Sports (Volleyball, Basketball)" },
          { text: "Chapter 4: Individual Sports (Badminton, Track)" },
        ],
      },
      {
        text: "Module 3: Health and Wellness",
        chapters: [
          { text: "Chapter 5: Nutrition and Mental Health" },
          { text: "Chapter 6: Injury Prevention and First Aid" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Career and Technology Foundations AB",
    courseCode: "CTF 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Exploratory Streams",
        chapters: [
          { text: "Chapter 1: Robotics and Coding (STEM)" },
          { text: "Chapter 2: Culinary Arts and Food Science" },
          { text: "Chapter 3: Woodworking and Design" },
          { text: "Chapter 4: Digital Media and Graphic Design" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Health and Life Skills AB",
    courseCode: "HLS 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Unit 1: Personal Wellness",
        chapters: [
          { text: "Chapter 1: Mental Health Strategies" },
          { text: "Chapter 2: Healthy Relationships" },
        ],
      },
      {
        text: "Unit 2: Financial Literacy",
        chapters: [
          { text: "Chapter 3: Budgeting and Saving" },
          { text: "Chapter 4: Consumer Awareness" },
        ],
      },
      {
        text: "Unit 3: Substance Use and Safety",
        chapters: [
          { text: "Chapter 5: Risks of Alcohol/Drugs" },
          { text: "Chapter 6: Decision-Making Skills" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Fine Arts AB",
    courseCode: "ART/DRAMA/MUS 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Visual Art",
        chapters: [
          { text: "Chapter 1: Drawing, Painting, and Sculpture Techniques" },
        ],
      },
      {
        text: "Drama",
        chapters: [{ text: "Chapter 2: Improvisation and Script Analysis" }],
      },
      {
        text: "Music",
        chapters: [{ text: "Chapter 3: Performance and Composition" }],
      },
    ],
  },
  {
    label: "Grade 9 Indigenous Studies AB",
    courseCode: "INDG 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      {
        text: "Unit 1: Treaty Education",
        chapters: [
          { text: "Chapter 1: History of Treaties 6, 7, and 8" },
          { text: "Chapter 2: Land Acknowledgments" },
        ],
      },
      {
        text: "Unit 2: Residential Schools",
        chapters: [
          { text: "Chapter 3: Truth and Reconciliation Commission" },
          { text: "Chapter 4: Indigenous Resilience" },
        ],
      },
      {
        text: "Unit 3: Contemporary Issues",
        chapters: [
          { text: "Chapter 5: Indigenous Rights and Land Stewardship" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 French as a Second Language AB",
    courseCode: "FSL 9 (Alberta Curriculum)",
    image: AlbertaGrade9Image,
    units: [
      { text: "Unit 1: La vie quotidienne", chapters: [] },
      { text: "Unit 2: Les voyages", chapters: [] },
      { text: "Unit 3: Les médias", chapters: [] },
    ],
  },
];

const AlbertaGrade10Subjects = [
  {
    label: "Grade 10 Science AB",
    courseCode: "SCI 10 (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Unit A: Energy and Matter in Chemical Change",
        chapters: [
          { text: "Chapter 1: Atomic Structure and Bonding" },
          { text: "Chapter 2: Chemical Reactions and Conservation of Mass" },
          { text: "Chapter 3: Acids, Bases, and Neutralization" },
        ],
      },
      {
        text: "Unit B: Energy Flow in Technological Systems",
        chapters: [
          { text: "Chapter 4: Thermodynamics and Heat Transfer" },
          { text: "Chapter 5: Energy Efficiency and Power Generation" },
        ],
      },
      {
        text: "Unit C: Cycling of Matter in Living Systems",
        chapters: [
          { text: "Chapter 6: Photosynthesis and Cellular Respiration" },
          { text: "Chapter 7: Nutrient Cycles in Ecosystems" },
        ],
      },
      {
        text: "Unit D: Energy Flow in Global Systems",
        chapters: [
          { text: "Chapter 8: Climate Change and Energy Balance" },
          { text: "Chapter 9: Renewable vs. Non-Renewable Resources" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Mathematics AB",
    courseCode: "MATH 10C (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Unit 1: Measurement and Geometry",
        chapters: [
          { text: "Chapter 1: Trigonometry and Right Triangles" },
          { text: "Chapter 2: Surface Area and Volume Calculations" },
        ],
      },
      {
        text: "Unit 2: Algebra and Number",
        chapters: [
          { text: "Chapter 3: Polynomial Operations and Factoring" },
          { text: "Chapter 4: Rational Expressions and Equations" },
        ],
      },
      {
        text: "Unit 3: Linear Functions",
        chapters: [
          { text: "Chapter 5: Slope and Rate of Change" },
          { text: "Chapter 6: Systems of Linear Equations" },
        ],
      },
      {
        text: "Unit 4: Quadratic Functions",
        chapters: [
          { text: "Chapter 7: Graphing Parabolas" },
          { text: "Chapter 8: Solving Quadratic Equations" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 English Language Arts AB",
    courseCode: "ELA 10-1 or 10-2 (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Unit 1: Literary Studies",
        chapters: [
          { text: "Chapter 1: Novel Analysis (e.g., To Kill a Mockingbird)" },
          { text: "Chapter 2: Poetry and Shakespearean Drama" },
        ],
      },
      {
        text: "Unit 2: Composition",
        chapters: [
          { text: "Chapter 3: Persuasive Essays and Research Papers" },
          { text: "Chapter 4: Creative Writing and Narratives" },
        ],
      },
      {
        text: "Unit 3: Media and Oral Communication",
        chapters: [
          { text: "Chapter 5: Digital Media Production" },
          { text: "Chapter 6: Debate and Public Speaking" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Social Studies AB",
    courseCode: "SOC 10-1 or 10-2 (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Unit 1: Globalization and Identity",
        chapters: [
          { text: "Chapter 1: Cultural Homogenization vs. Hybridization" },
          { text: "Chapter 2: Transnational Corporations" },
        ],
      },
      {
        text: "Unit 2: Historical Globalization",
        chapters: [
          { text: "Chapter 3: Imperialism and Colonialism" },
          { text: "Chapter 4: Legacy of Residential Schools" },
        ],
      },
      {
        text: "Unit 3: Economic and Environmental Globalization",
        chapters: [
          { text: "Chapter 5: Free Trade Agreements (e.g., NAFTA)" },
          { text: "Chapter 6: Climate Change and Global Responsibility" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Physical Education AB",
    courseCode: "PE 10 (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Module 1: Fitness and Movement",
        chapters: [
          { text: "Chapter 1: Weight Training and Cardio" },
          { text: "Chapter 2: Yoga/Pilates Fundamentals" },
        ],
      },
      {
        text: "Module 2: Sports and Leadership",
        chapters: [
          { text: "Chapter 3: Team Sports (Soccer, Basketball)" },
          { text: "Chapter 4: Outdoor Education (Hiking, Orienteering)" },
        ],
      },
      {
        text: "Module 3: Health and Wellness",
        chapters: [
          { text: "Chapter 5: Mental Health Strategies" },
          { text: "Chapter 6: Nutrition and Body Image" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Career and Life Management AB",
    courseCode: "CALM 20 (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Unit 1: Personal Health",
        chapters: [
          { text: "Chapter 1: Stress Management and Resilience" },
          { text: "Chapter 2: Healthy Relationships and Consent" },
        ],
      },
      {
        text: "Unit 2: Financial Literacy",
        chapters: [
          { text: "Chapter 3: Budgeting and Debt Management" },
          { text: "Chapter 4: Post-Secondary Funding Options" },
        ],
      },
      {
        text: "Unit 3: Career Planning",
        chapters: [
          { text: "Chapter 5: Resume Writing and Interview Skills" },
          { text: "Chapter 6: Alberta Labour Market Trends" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Career and Technology Studies (CTS) AB",
    courseCode: "Various (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Stream 1: Business and Technology",
        chapters: [
          { text: "Chapter 1: ENT1010: Entrepreneurship" },
          { text: "Chapter 2: COM1005: Digital Communication" },
        ],
      },
      {
        text: "Stream 2: Health and Human Services",
        chapters: [
          { text: "Chapter 3: HCS1000: Medical Terminology" },
          { text: "Chapter 4: HSS1020: Nutrition and Wellness" },
        ],
      },
      {
        text: "Stream 3: Trades and Manufacturing",
        chapters: [
          { text: "Chapter 5: CON1010: Carpentry Basics" },
          { text: "Chapter 6: MEC1010: Automotive Fundamentals" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Art AB",
    courseCode: "ART 10 (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Drawing and Painting",
        chapters: [
          { text: "Chapter 1: Portraiture and Figure Drawing" },
          { text: "Chapter 2: Watercolor and Acrylic Techniques" },
        ],
      },
      {
        text: "Sculpture and Design",
        chapters: [
          { text: "Chapter 3: 3D Art and Mixed Media" },
          { text: "Chapter 4: Digital Art and Photography" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 French as a Second Language AB",
    courseCode: "FSL 10 (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      { text: "Unit 1: Identité et relations", chapters: [] },
      { text: "Unit 2: Voyages et aventures", chapters: [] },
      { text: "Unit 3: Technologie et médias", chapters: [] },
    ],
  },
  {
    label: "Grade 10 Indigenous Studies AB",
    courseCode: "INDG 10 (Alberta Curriculum)",
    image: AlbertaGrade10Image,
    units: [
      {
        text: "Unit 1: Indigenous Governance",
        chapters: [
          { text: "Chapter 1: Traditional Leadership Models" },
          { text: "Chapter 2: Modern Treaty Negotiations" },
        ],
      },
      {
        text: "Unit 2: Land and Resource Stewardship",
        chapters: [
          { text: "Chapter 3: Environmental Justice" },
          { text: "Chapter 4: Sustainable Development" },
        ],
      },
      {
        text: "Unit 3: Contemporary Indigenous Art",
        chapters: [{ text: "Chapter 5: Literature, Film, and Visual Arts" }],
      },
    ],
  },
];

const AlbertaGrade11Subjects = [
  {
    label: "Science AB Grade 11",
    courseCode: "SCI 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit A: Chemical Changes",
        chapters: [
          { text: "Chapter 1: Chemical Bonding and Reactions" },
          { text: "Chapter 2: Stoichiometry and Gas Laws" },
          { text: "Chapter 3: Solutions and Solubility" },
        ],
      },
      {
        text: "Unit B: Changes in Motion",
        chapters: [
          { text: "Chapter 4: Kinematics and Dynamics" },
          { text: "Chapter 5: Forces and Newton's Laws" },
        ],
      },
      {
        text: "Unit C: The Changing Earth",
        chapters: [
          { text: "Chapter 6: Plate Tectonics and Earthquakes" },
          { text: "Chapter 7: Weathering and Erosion" },
        ],
      },
      {
        text: "Unit D: Biological Diversity",
        chapters: [
          { text: "Chapter 8: Evolution and Adaptation" },
          { text: "Chapter 9: Ecosystem Stability" },
        ],
      },
    ],
  },
  {
    label: "Chemistry AB Grade 11",
    courseCode: "CHEM 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit A: Matter and Chemical Bonding",
        chapters: [
          { text: "Atomic Structure and Periodic Trends" },
          { text: "Ionic and Covalent Compounds" },
        ],
      },
      {
        text: "Unit B: Chemical Reactions",
        chapters: [
          { text: "Stoichiometry and Limiting Reactants" },
          { text: "Acid-Base Reactions" },
        ],
      },
      {
        text: "Unit C: Solutions and Solubility",
        chapters: [
          { text: "Concentration and Dilution" },
          { text: "Properties of Solutions" },
        ],
      },
      {
        text: "Unit D: Gases and Atmospheric Chemistry",
        chapters: [
          { text: "Gas Laws and Kinetic Molecular Theory" },
          { text: "Air Quality and Pollution" },
        ],
      },
    ],
  },
  {
    label: "Physics AB Grade 11",
    courseCode: "PHYS 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit A: Kinematics",
        chapters: [
          { text: "Motion in One and Two Dimensions" },
          { text: "Graphical Analysis of Motion" },
        ],
      },
      {
        text: "Unit B: Dynamics",
        chapters: [
          { text: "Newton's Laws and Applications" },
          { text: "Friction and Inclined Planes" },
        ],
      },
      {
        text: "Unit C: Circular Motion and Gravitation",
        chapters: [
          { text: "Centripetal Force and Acceleration" },
          { text: "Kepler's Laws and Satellite Motion" },
        ],
      },
      {
        text: "Unit D: Mechanical Waves",
        chapters: [
          { text: "Wave Properties and Sound" },
          { text: "Standing Waves and Resonance" },
        ],
      },
    ],
  },
  {
    label: "Mathematics AB Grade 11",
    courseCode: "MATH 20-1 or 20-2 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit 1: Quadratic Functions and Equations",
        chapters: [
          { text: "Graphing Parabolas" },
          { text: "Solving Quadratic Equations" },
        ],
      },
      {
        text: "Unit 2: Radical Expressions and Equations",
        chapters: [
          { text: "Simplifying Radicals" },
          { text: "Solving Radical Equations" },
        ],
      },
      {
        text: "Unit 3: Rational Expressions and Equations",
        chapters: [
          { text: "Simplifying Rational Expressions" },
          { text: "Solving Rational Equations" },
        ],
      },
      {
        text: "Unit 4: Trigonometry",
        chapters: [
          { text: "Sine and Cosine Laws" },
          { text: "Trigonometric Identities" },
        ],
      },
    ],
  },
  {
    label: "English Language Arts AB Grade 11",
    courseCode: "ELA 20-1 or 20-2 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit 1: Literary Studies",
        chapters: [
          { text: "Novel Study (e.g., The Great Gatsby)" },
          { text: "Shakespearean Drama (e.g., Macbeth)" },
        ],
      },
      {
        text: "Unit 2: Composition",
        chapters: [
          { text: "Literary Analysis Essays" },
          { text: "Creative Writing and Poetry" },
        ],
      },
      {
        text: "Unit 3: Media and Oral Communication",
        chapters: [
          { text: "Film Analysis and Production" },
          { text: "Debate and Persuasive Speaking" },
        ],
      },
    ],
  },
  {
    label: "Social Studies AB Grade 11",
    courseCode: "SOC 20-1 or 20-2 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit 1: Nationalism and Identity",
        chapters: [
          { text: "Civic vs. Ethnic Nationalism" },
          { text: "Canadian National Identity" },
        ],
      },
      {
        text: "Unit 2: Historical Nationalism",
        chapters: [
          { text: "French Revolution and Nationalism" },
          { text: "Indigenous Nationalism in Canada" },
        ],
      },
      {
        text: "Unit 3: Contemporary Nationalism",
        chapters: [
          { text: "Quebec Sovereignty Movement" },
          { text: "Globalization vs. Nationalism" },
        ],
      },
    ],
  },
  {
    label: "Biology AB Grade 11",
    courseCode: "BIO 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit A: Energy and Matter Exchange in the Biosphere",
        chapters: [
          { text: "Photosynthesis and Cellular Respiration" },
          { text: "Nutrient Cycles (Carbon, Nitrogen)" },
        ],
      },
      {
        text: "Unit B: Ecosystems and Population Change",
        chapters: [
          { text: "Ecological Succession" },
          { text: "Natural Selection and Adaptation" },
        ],
      },
      {
        text: "Unit C: Human Systems",
        chapters: [
          { text: "Digestive and Circulatory Systems" },
          { text: "Homeostasis and Feedback Mechanisms" },
        ],
      },
    ],
  },
  {
    label: "Career and Life Management AB Grade 11",
    courseCode: "CALM 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit 1: Personal Health",
        chapters: [
          { text: "Mental Health and Stress Management" },
          { text: "Healthy Relationships and Communication" },
        ],
      },
      {
        text: "Unit 2: Financial Literacy",
        chapters: [
          { text: "Budgeting and Saving for the Future" },
          { text: "Understanding Credit and Debt" },
        ],
      },
      {
        text: "Unit 3: Career Planning",
        chapters: [
          { text: "Resume Writing and Interview Skills" },
          { text: "Exploring Post-Secondary Options" },
        ],
      },
    ],
  },
  {
    label: "Psychology AB Grade 11",
    courseCode: "PSYCH 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit 1: Introduction to Psychology",
        chapters: [
          { text: "Major Psychological Perspectives" },
          { text: "Research Methods and Ethics" },
        ],
      },
      {
        text: "Unit 2: Human Development",
        chapters: [
          { text: "Cognitive and Moral Development" },
          { text: "Adolescence and Identity Formation" },
        ],
      },
      {
        text: "Unit 3: Learning and Memory",
        chapters: [
          { text: "Classical and Operant Conditioning" },
          { text: "Memory Processes and Forgetting" },
        ],
      },
    ],
  },
  {
    label: "Indigenous Studies AB Grade 11",
    courseCode: "INDG 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit 1: Indigenous Governance",
        chapters: [
          { text: "Traditional Leadership Models" },
          { text: "Modern Treaty Negotiations" },
        ],
      },
      {
        text: "Unit 2: Land and Resource Stewardship",
        chapters: [
          { text: "Environmental Justice" },
          { text: "Sustainable Development" },
        ],
      },
      {
        text: "Unit 3: Contemporary Indigenous Art",
        chapters: [{ text: "Literature, Film, and Visual Arts" }],
      },
    ],
  },
  {
    label: "Career and Technology Studies (CTS) AB Grade 11",
    courseCode: "Various (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Stream 1: Business and Technology",
        chapters: [
          { text: "ENT2010: Advanced Entrepreneurship" },
          { text: "COM2015: Web Design and Development" },
        ],
      },
      {
        text: "Stream 2: Health and Human Services",
        chapters: [
          { text: "HCS2020: Anatomy and Physiology" },
          { text: "HSS2030: Mental Health First Aid" },
        ],
      },
      {
        text: "Stream 3: Trades and Manufacturing",
        chapters: [
          { text: "CON2010: Intermediate Carpentry" },
          { text: "MEC2020: Automotive Systems" },
        ],
      },
    ],
  },
  {
    label: "Art AB Grade 11",
    courseCode: "ART 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Drawing and Painting",
        chapters: [
          { text: "Portraiture and Figure Drawing" },
          { text: "Watercolor and Acrylic Techniques" },
        ],
      },
      {
        text: "Sculpture and Design",
        chapters: [
          { text: "3D Art and Mixed Media" },
          { text: "Digital Art and Photography" },
        ],
      },
    ],
  },
  {
    label: "French as a Second Language AB Grade 11",
    courseCode: "FSL 20 (Alberta Curriculum)",
    image: AlbertaGrade11Image,
    units: [
      {
        text: "Unit 1: Identité et relations (Identity & Relationships)",
        chapters: [],
      },
      {
        text: "Unit 2: Voyages et aventures (Travel & Adventure)",
        chapters: [],
      },
      {
        text: "Unit 3: Technologie et médias (Technology & Media)",
        chapters: [],
      },
    ],
  },
];

const AlbertaGrade12Subjects = [
  {
    label: "Grade 12 Science AB",
    courseCode: "SCI 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit A: Biology",
        chapters: [
          { text: "Chapter 1: Nervous and Endocrine Systems" },
          { text: "Chapter 2: Reproduction and Development" },
        ],
      },
      {
        text: "Unit B: Chemistry",
        chapters: [
          { text: "Chapter 3: Organic Chemistry" },
          { text: "Chapter 4: Electrochemistry" },
        ],
      },
      {
        text: "Unit C: Physics",
        chapters: [
          { text: "Chapter 5: Energy and Momentum" },
          { text: "Chapter 6: Electromagnetic Radiation" },
        ],
      },
      {
        text: "Unit D: Environmental Science",
        chapters: [
          { text: "Chapter 7: Population Dynamics" },
          { text: "Chapter 8: Resource Management" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Chemistry AB",
    courseCode: "CHEM 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit A: Thermochemical Changes",
        chapters: [
          { text: "Enthalpy and Hess's Law" },
          { text: "Calorimetry" },
        ],
      },
      {
        text: "Unit B: Electrochemical Changes",
        chapters: [
          { text: "Redox Reactions" },
          { text: "Batteries and Corrosion" },
        ],
      },
      {
        text: "Unit C: Organic Chemistry",
        chapters: [
          { text: "Hydrocarbons and Functional Groups" },
          { text: "Polymers and Biomolecules" },
        ],
      },
      {
        text: "Unit D: Equilibrium",
        chapters: [
          { text: "Le Chatelier's Principle" },
          { text: "Acid-Base Systems" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Physics AB",
    courseCode: "PHYS 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit A: Momentum and Impulse",
        chapters: [
          { text: "Collisions in 1D and 2D" },
          { text: "Conservation of Momentum" },
        ],
      },
      {
        text: "Unit B: Forces and Fields",
        chapters: [
          { text: "Gravitational/Electric/Magnetic Fields" },
          { text: "Applications (e.g., Motors, Generators)" },
        ],
      },
      {
        text: "Unit C: Electromagnetic Radiation",
        chapters: [
          { text: "Wave-Particle Duality" },
          { text: "Quantum Physics" },
        ],
      },
      {
        text: "Unit D: Atomic Physics",
        chapters: [
          { text: "Nuclear Reactions" },
          { text: "Radiation and Medical Imaging" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Mathematics AB",
    courseCode: "MATH 30-1 or 30-2 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit 1: Transformations",
        chapters: [
          { text: "Function Operations" },
          { text: "Trigonometric Graphs" },
        ],
      },
      {
        text: "Unit 2: Trigonometry",
        chapters: [
          { text: "Identities and Equations" },
          { text: "Reciprocal Functions" },
        ],
      },
      {
        text: "Unit 3: Exponential/Logarithmic Functions",
        chapters: [
          { text: "Growth and Decay Models" },
          { text: "Solving Exponential Equations" },
        ],
      },
      {
        text: "Unit 4: Polynomial/Rational Functions",
        chapters: [
          { text: "Graphing and Inequalities" },
          { text: "Partial Fractions" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 English Language Arts AB",
    courseCode: "ELA 30-1 or 30-2 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit 1: Critical/Dialectical Response",
        chapters: [
          { text: "Novel Study (e.g., 1984)" },
          { text: "Shakespeare (e.g., Hamlet)" },
        ],
      },
      {
        text: "Unit 2: Personal/Creative Response",
        chapters: [
          { text: "Poetry and Short Stories" },
          { text: "Multigenre Writing" },
        ],
      },
      {
        text: "Unit 3: Visual/Multimedia Texts",
        chapters: [{ text: "Film Analysis" }, { text: "Digital Storytelling" }],
      },
    ],
  },
  {
    label: "Grade 12 Social Studies AB",
    courseCode: "SOC 30-1 or 30-2 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit 1: Liberalism",
        chapters: [
          { text: "Classical vs. Modern Liberalism" },
          { text: "Canadian Charter of Rights" },
        ],
      },
      {
        text: "Unit 2: Ideologies",
        chapters: [
          { text: "Socialism, Conservatism, Fascism" },
          { text: "Environmentalism" },
        ],
      },
      {
        text: "Unit 3: Globalization",
        chapters: [
          { text: "Economic Interdependence" },
          { text: "Cultural Homogenization" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Biology AB",
    courseCode: "BIO 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit A: Nervous/Endocrine Systems",
        chapters: [
          { text: "Neuron Structure/Function" },
          { text: "Hormonal Regulation" },
        ],
      },
      {
        text: "Unit B: Reproduction/Development",
        chapters: [
          { text: "Human Reproductive Systems" },
          { text: "Genetic Inheritance" },
        ],
      },
      {
        text: "Unit C: Cell Division/Genetics",
        chapters: [
          { text: "Meiosis/Mitosis" },
          { text: "DNA Replication/Protein Synthesis" },
        ],
      },
      {
        text: "Unit D: Population Dynamics",
        chapters: [
          { text: "Ecosystem Stability" },
          { text: "Human Impact on Biodiversity" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Career and Life Management AB",
    courseCode: "CALM 20 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit 1: Post-Secondary Transition",
        chapters: [{ text: "Career Pathways" }, { text: "Financial Planning" }],
      },
      {
        text: "Unit 2: Healthy Relationships",
        chapters: [
          { text: "Communication Skills" },
          { text: "Conflict Resolution" },
        ],
      },
      {
        text: "Unit 3: Independent Living",
        chapters: [{ text: "Tenant Rights" }, { text: "Time Management" }],
      },
    ],
  },
  {
    label: "Grade 12 Psychology AB",
    courseCode: "PSYCH 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit 1: Abnormal Psychology",
        chapters: [{ text: "Anxiety/Mood Disorders" }, { text: "Therapies" }],
      },
      {
        text: "Unit 2: Social Psychology",
        chapters: [
          { text: "Conformity/Prejudice" },
          { text: "Group Dynamics" },
        ],
      },
      {
        text: "Unit 3: Cognition",
        chapters: [
          { text: "Memory/Intelligence" },
          { text: "Problem-Solving" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Indigenous Studies AB",
    courseCode: "INDG 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit 1: Contemporary Issues",
        chapters: [{ text: "Land Claims" }, { text: "Self-Governance" }],
      },
      {
        text: "Unit 2: Indigenous Leadership",
        chapters: [{ text: "Role Models" }, { text: "Activism" }],
      },
      {
        text: "Unit 3: Reconciliation",
        chapters: [{ text: "TRC Calls to Action" }, { text: "Allyship" }],
      },
    ],
  },
  {
    label: "Grade 12 Career and Technology Studies (CTS) AB",
    courseCode: "Various (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Stream 1: Advanced Business",
        chapters: [
          { text: "ENT3010: Business Planning" },
          { text: "COM3015: Digital Marketing" },
        ],
      },
      {
        text: "Stream 2: Health Sciences",
        chapters: [
          { text: "HCS3020: Medical Lab Assisting" },
          { text: "HSS3050: Gerontology" },
        ],
      },
      {
        text: "Stream 3: Advanced Trades",
        chapters: [
          { text: "CON3010: Framing and Finishing" },
          { text: "MEC3050: Automotive Diagnostics" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Art AB",
    courseCode: "ART 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Portfolio Development",
        chapters: [{ text: "Thematic Series" }, { text: "Artist Statements" }],
      },
      {
        text: "Advanced Techniques",
        chapters: [{ text: "Oil Painting" }, { text: "Digital Media" }],
      },
      {
        text: "Art History",
        chapters: [{ text: "Modern Movements" }, { text: "Canadian Artists" }],
      },
    ],
  },
  {
    label: "Grade 12 French as a Second Language AB",
    courseCode: "FSL 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit 1: Littérature francophone",
        chapters: [{ text: "Novel Excerpts" }, { text: "Poetry Analysis" }],
      },
      {
        text: "Unit 2: Débats contemporains",
        chapters: [
          { text: "Environmental Issues" },
          { text: "Social Justice" },
        ],
      },
      {
        text: "Unit 3: Préparation postsecondaire",
        chapters: [
          { text: "University Readiness" },
          { text: "Professional French" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Forensic Science AB",
    courseCode: "FORENSIC 30 (Alberta Curriculum)",
    image: AlbertaGrade12Image,
    units: [
      {
        text: "Unit 1: Crime Scene Analysis",
        chapters: [{ text: "Fingerprinting" }, { text: "Bloodstain Patterns" }],
      },
      {
        text: "Unit 2: Lab Techniques",
        chapters: [{ text: "DNA Profiling" }, { text: "Toxicology" }],
      },
      {
        text: "Unit 3: Legal Aspects",
        chapters: [{ text: "Courtroom Procedures" }, { text: "Case Studies" }],
      },
    ],
  },
];

const BCGrade9Subjects = [
  {
    label: "Grade 9 Science BC",
    courseCode: "SCIENCE 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Unit 1: Biology",
        chapters: [
          { text: "Chapter 1: Reproduction (mitosis/meiosis)" },
          { text: "Chapter 2: Human Sexual Reproduction" },
          { text: "Chapter 3: Genetics and Heredity" },
        ],
      },
      {
        text: "Unit 2: Chemistry",
        chapters: [
          { text: "Chapter 1: Atomic Theory" },
          { text: "Chapter 2: Elements and Compounds" },
          { text: "Chapter 3: Chemical Reactions" },
        ],
      },
      {
        text: "Unit 3: Physics",
        chapters: [
          { text: "Chapter 1: Static and Current Electricity" },
          { text: "Chapter 2: Series and Parallel Circuits" },
        ],
      },
      {
        text: "Unit 4: Earth Science",
        chapters: [
          { text: "Chapter 1: Solar System and Space Exploration" },
          { text: "Chapter 2: Cosmic Radiation and Space Technologies" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Mathematics BC",
    courseCode: "MATHEMATICS 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Unit 1: Number Sense",
        chapters: [
          { text: "Chapter 1: Rational Numbers" },
          { text: "Chapter 2: Square Roots and Exponents" },
        ],
      },
      {
        text: "Unit 2: Algebra",
        chapters: [
          { text: "Chapter 1: Polynomials" },
          { text: "Chapter 2: Linear Equations" },
        ],
      },
      {
        text: "Unit 3: Measurement",
        chapters: [
          { text: "Chapter 1: Circle Geometry" },
          { text: "Chapter 2: Surface Area and Volume" },
        ],
      },
      {
        text: "Unit 4: Data Analysis",
        chapters: [
          { text: "Chapter 1: Probability" },
          { text: "Chapter 2: Statistics and Graphs" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 English BC",
    courseCode: "ENGLISH 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Unit 1: Literary Studies",
        chapters: [
          {
            text: 'Chapter 1: Short Stories (e.g., "The Lottery" by Shirley Jackson)',
          },
          { text: "Chapter 2: Novel Study (e.g., The Giver)" },
        ],
      },
      {
        text: "Unit 2: Composition",
        chapters: [
          { text: "Chapter 1: Narrative Writing" },
          { text: "Chapter 2: Expository Essays" },
        ],
      },
      {
        text: "Unit 3: Oral Language",
        chapters: [
          { text: "Chapter 1: Public Speaking" },
          { text: "Chapter 2: Group Discussions" },
        ],
      },
      {
        text: "Unit 4: Media Literacy",
        chapters: [
          { text: "Chapter 1: Advertising Analysis" },
          { text: "Chapter 2: Digital Citizenship" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Social Studies BC",
    courseCode: "SOCIAL STUDIES 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Unit 1: Early Civilizations",
        chapters: [
          { text: "Chapter 1: Mesopotamia and Ancient Egypt" },
          { text: "Chapter 2: Greek and Roman Societies" },
        ],
      },
      {
        text: "Unit 2: Middle Ages",
        chapters: [
          { text: "Chapter 1: Feudalism" },
          { text: "Chapter 2: Renaissance" },
        ],
      },
      {
        text: "Unit 3: Indigenous Societies",
        chapters: [
          { text: "Chapter 1: First Peoples of Canada" },
          { text: "Chapter 2: European Contact" },
        ],
      },
      {
        text: "Unit 4: Revolutions",
        chapters: [
          { text: "Chapter 1: Industrial Revolution" },
          { text: "Chapter 2: Political Revolutions" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Physical and Health Education BC",
    courseCode: "PHE 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Module 1: Active Living",
        chapters: [
          { text: "Chapter 1: Fitness Components" },
          { text: "Chapter 2: Personal Fitness Plans" },
        ],
      },
      {
        text: "Module 2: Movement Skills",
        chapters: [
          { text: "Chapter 1: Team Sports (Basketball, Soccer)" },
          { text: "Chapter 2: Individual Activities (Yoga, Track)" },
        ],
      },
      {
        text: "Module 3: Healthy Relationships",
        chapters: [
          { text: "Chapter 1: Mental Health Awareness" },
          { text: "Chapter 2: Consent Education" },
        ],
      },
      {
        text: "Module 4: Safety",
        chapters: [
          { text: "Chapter 1: First Aid Basics" },
          { text: "Chapter 2: Online Safety" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Applied Design, Skills, and Technologies BC",
    courseCode: "ADST 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Exploratory Modules",
        chapters: [
          { text: "Chapter 1: Coding and Robotics" },
          { text: "Chapter 2: Woodworking" },
          { text: "Chapter 3: Digital Media Design" },
          { text: "Chapter 4: Foods and Nutrition" },
        ],
      },
      {
        text: "Core Skills",
        chapters: [
          { text: "Chapter 1: Design Thinking Process" },
          { text: "Chapter 2: Project Management" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Arts Education BC",
    courseCode: "ARTS 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Visual Art",
        chapters: [
          { text: "Chapter 1: Drawing Techniques" },
          { text: "Chapter 2: Painting and Color Theory" },
        ],
      },
      {
        text: "Drama",
        chapters: [
          { text: "Chapter 1: Improvisation" },
          { text: "Chapter 2: Scene Work" },
        ],
      },
      {
        text: "Music",
        chapters: [
          { text: "Chapter 1: Composition" },
          { text: "Chapter 2: Performance" },
        ],
      },
      {
        text: "Dance",
        chapters: [
          { text: "Chapter 1: Choreography" },
          { text: "Chapter 2: Cultural Dance Forms" },
        ],
      },
    ],
  },
  {
    label: "Grade 9 French BC",
    courseCode: "FRENCH 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Unit 1: La vie quotidienne",
        chapters: [{ text: "Chapter 1: La vie quotidienne (Daily Life)" }],
      },
      {
        text: "Unit 2: Les loisirs",
        chapters: [{ text: "Chapter 1: Les loisirs (Leisure Activities)" }],
      },
      {
        text: "Unit 3: Les voyages",
        chapters: [{ text: "Chapter 1: Les voyages (Travel)" }],
      },
      {
        text: "Unit 4: La technologie",
        chapters: [{ text: "Chapter 1: La technologie (Technology)" }],
      },
    ],
  },
  {
    label: "Grade 9 Career Education BC",
    courseCode: "CAREER EDUCATION 9 (BC Curriculum)",
    image: BCGrade9Image,
    units: [
      {
        text: "Unit 1: Self-Discovery",
        chapters: [
          { text: "Chapter 1: Skills and Interests Assessment" },
          { text: "Chapter 2: Learning Styles" },
        ],
      },
      {
        text: "Unit 2: Career Exploration",
        chapters: [
          { text: "Chapter 1: Job Shadowing" },
          { text: "Chapter 2: High School Planning" },
        ],
      },
      {
        text: "Unit 3: Digital Literacy",
        chapters: [
          { text: "Chapter 1: Online Portfolios" },
          { text: "Chapter 2: Resume Basics" },
        ],
      },
    ],
  },
];

const BCGrade10Subjects = [
  {
    label: "Grade 10 Science BC",
    courseCode: "SCIENCE 10 (BC Curriculum)",
    image: BCGrade10Image,
    units: [
      {
        text: "Unit 1: Genetics",
        chapters: [
          { text: "Chapter 1: DNA structure and inheritance" },
          { text: "Chapter 2: Natural and artificial selection" },
        ],
      },
      {
        text: "Unit 2: Chemistry",
        chapters: [
          { text: "Chapter 1: Atomic theory and periodic table" },
          { text: "Chapter 2: Chemical reactions and balancing equations" },
        ],
      },
      {
        text: "Unit 3: Energy",
        chapters: [
          { text: "Chapter 1: Kinetic and potential energy" },
          { text: "Chapter 2: Conservation of energy" },
        ],
      },
      {
        text: "Unit 4: Earth Science",
        chapters: [
          { text: "Chapter 1: Plate tectonics and earthquakes" },
          { text: "Chapter 2: Energy resources and sustainability" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Mathematics BC",
    courseCode: "MATHEMATICS 10 (BC Curriculum)",
    image: BCGrade10Image,
    units: [
      {
        text: "Unit 1: Measurement",
        chapters: [
          { text: "Chapter 1: Surface area and volume" },
          { text: "Chapter 2: Trigonometry of right triangles" },
        ],
      },
      {
        text: "Unit 2: Algebra",
        chapters: [
          { text: "Chapter 1: Polynomial operations" },
          { text: "Chapter 2: Factoring and solving equations" },
        ],
      },
      {
        text: "Unit 3: Linear Relations",
        chapters: [
          { text: "Chapter 1: Slope and rate of change" },
          { text: "Chapter 2: Graphing linear equations" },
        ],
      },
      {
        text: "Unit 4: Financial Literacy",
        chapters: [
          { text: "Chapter 1: Budgeting and compound interest" },
          { text: "Chapter 2: Credit and debt management" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 English BC",
    courseCode: "ENGLISH 10 (BC Curriculum)",
    image: BCGrade10Image,
    units: [
      {
        text: "Unit 1: Literary Studies",
        chapters: [
          { text: "Chapter 1: Novel study (e.g., The Hunger Games)" },
          { text: "Chapter 2: Poetry and short stories" },
        ],
      },
      {
        text: "Unit 2: Composition",
        chapters: [
          { text: "Chapter 1: Narrative and persuasive writing" },
          { text: "Chapter 2: Research skills and citations" },
        ],
      },
      {
        text: "Unit 3: Media Literacy",
        chapters: [
          { text: "Chapter 1: Advertising analysis" },
          { text: "Chapter 2: Digital storytelling" },
        ],
      },
    ],
  },
  {
    label: "Grade 10 Social Studies BC",
    courseCode: "SOCIAL STUDIES 10 (BC Curriculum)",
    image: BCGrade10Image,
    units: [
      {
        text: "Unit 1: 1914-1929",
        chapters: [
          { text: "Chapter 1: WWI and Canadian autonomy" },
          { text: "Chapter 2: Roaring Twenties" },
        ],
      },
      {
        text: "Unit 2: 1929-1945",
        chapters: [
          { text: "Chapter 1: Great Depression" },
          { text: "Chapter 2: WWII and Holocaust" },
        ],
      },
      {
        text: "Unit 3: 1945-2000s",
        chapters: [
          { text: "Chapter 1: Cold War" },
          { text: "Chapter 2: Globalization and technology" },
        ],
      },
    ],
  },
];

const BCGrade11Subjects = [
  {
    label: "Grade 11 Science BC",
    courseCode: "SCIENCE 11 (BC Curriculum)",
    image: BCGrade11Image,
    units: [
      {
        text: "Biology",
        chapters: [
          { text: "Chapter 1: Evolution and biodiversity" },
          { text: "Chapter 2: Ecological principles" },
        ],
      },
      {
        text: "Chemistry",
        chapters: [
          { text: "Chapter 1: Atoms and moles" },
          { text: "Chapter 2: Solutions and solubility" },
        ],
      },
      {
        text: "Physics",
        chapters: [
          { text: "Chapter 1: Kinematics and dynamics" },
          { text: "Chapter 2: Energy transformations" },
        ],
      },
    ],
  },
  {
    label: "Grade 11 Mathematics BC",
    courseCode: "FOUNDATIONS 11 or PRE-CALC 11 (BC Curriculum)",
    image: BCGrade11Image,
    units: [
      {
        text: "Foundations 11",
        chapters: [
          { text: "Chapter 1: Financial mathematics" },
          { text: "Chapter 2: Probability and statistics" },
        ],
      },
      {
        text: "Pre-Calculus 11",
        chapters: [
          { text: "Chapter 1: Quadratic functions" },
          { text: "Chapter 2: Trigonometry and radical equations" },
        ],
      },
    ],
  },
  {
    label: "Grade 11 English BC",
    courseCode: "ENGLISH 11 (BC Curriculum)",
    image: BCGrade11Image,
    units: [
      {
        text: "Literary Studies",
        chapters: [
          { text: "Chapter 1: Canadian literature" },
          { text: "Chapter 2: Shakespearean drama" },
        ],
      },
      {
        text: "Creative Writing",
        chapters: [
          { text: "Chapter 1: Poetry and short fiction" },
          { text: "Chapter 2: Digital media projects" },
        ],
      },
    ],
  },
];

const BCGrade12Subjects = [
  {
    label: "Grade 12 Science BC",
    courseCode: "SCIENCE 12 (BC Curriculum)",
    image: BCGrade12Image,
    units: [
      {
        text: "Biology",
        chapters: [
          { text: "Chapter 1: Cell biology and genetics" },
          { text: "Chapter 2: Homeostasis and physiology" },
        ],
      },
      {
        text: "Chemistry",
        chapters: [
          { text: "Chapter 1: Reaction kinetics" },
          { text: "Chapter 2: Organic chemistry" },
        ],
      },
      {
        text: "Physics",
        chapters: [
          { text: "Chapter 1: Electricity and magnetism" },
          { text: "Chapter 2: Quantum physics" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 Mathematics BC",
    courseCode: "PRE-CALC 12 or CALCULUS 12 (BC Curriculum)",
    image: BCGrade12Image,
    units: [
      {
        text: "Pre-Calculus 12",
        chapters: [
          { text: "Chapter 1: Transformations" },
          { text: "Chapter 2: Logarithms and exponentials" },
        ],
      },
      {
        text: "Calculus 12",
        chapters: [
          { text: "Chapter 1: Limits and derivatives" },
          { text: "Chapter 2: Applications of differentiation" },
        ],
      },
    ],
  },
  {
    label: "Grade 12 English BC",
    courseCode: "ENGLISH 12 (BC Curriculum)",
    image: BCGrade12Image,
    units: [
      {
        text: "Literary Studies",
        chapters: [
          { text: "Chapter 1: World literature" },
          { text: "Chapter 2: Critical analysis" },
        ],
      },
      {
        text: "Capstone Project",
        chapters: [
          { text: "Chapter 1: Research paper" },
          { text: "Chapter 2: Multimedia presentation" },
        ],
      },
    ],
  },
];

const QuebecSecondary3Subjects = [
  {
    label: "Science et Technologie QC",
    courseCode: "Science et Technologie (ST) - Cycle 1",
    image: QuebecSecondary3Image,
    units: [
      {
        text: "Unit A: Univers matériel",
        chapters: [
          { text: "Chapter 1: Propriétés de la matière" },
          { text: "Chapter 2: Transformations chimiques" },
        ],
      },
      {
        text: "Unit B: Univers vivant",
        chapters: [
          { text: "Chapter 3: Écosystèmes" },
          { text: "Chapter 4: Génétique de base" },
        ],
      },
      {
        text: "Unit C: Technologie",
        chapters: [
          { text: "Chapter 5: Design technique" },
          { text: "Chapter 6: Projets d'ingénierie" },
        ],
      },
    ],
  },
  {
    label: "Mathématique QC",
    courseCode: "Mathématique - Culture, société et technique (CST)",
    image: QuebecSecondary3Image,
    units: [
      {
        text: "Unit A: Algèbre",
        chapters: [
          { text: "Chapter 1: Équations du 1er degré" },
          { text: "Chapter 2: Fonctions linéaires" },
        ],
      },
      {
        text: "Unit B: Géométrie",
        chapters: [
          { text: "Chapter 3: Aires et volumes" },
          { text: "Chapter 4: Théorème de Pythagore" },
        ],
      },
      {
        text: "Unit C: Statistique",
        chapters: [
          { text: "Chapter 5: Analyse de données" },
          { text: "Chapter 6: Probabilités simples" },
        ],
      },
    ],
  },
];

const QuebecSecondary4Subjects = [
  {
    label: "Science et Technologie QC",
    courseCode: "Science et Technologie (ST) - Cycle 2",
    image: QuebecSecondary4Image,
    units: [
      {
        text: "Unit A: Chimie",
        chapters: [
          { text: "Chapter 1: Loi des gaz" },
          { text: "Chapter 2: Solutions et pH" },
        ],
      },
      {
        text: "Unit B: Physique",
        chapters: [
          { text: "Chapter 3: Cinématique" },
          { text: "Chapter 4: Électricité et magnétisme" },
        ],
      },
      {
        text: "Unit C: Biologie",
        chapters: [
          { text: "Chapter 5: Anatomie humaine" },
          { text: "Chapter 6: Homéostasie" },
        ],
      },
    ],
  },
  {
    label: "Histoire du Québec et Canada QC",
    courseCode: "Histoire - Programme obligatoire",
    image: QuebecSecondary4Image,
    units: [
      {
        text: "Unit A: Premiers occupants (avant 1608)",
        chapters: [{ text: "Chapter 1: Sociétés autochtones" }],
      },
      {
        text: "Unit B: Régime français (1608-1760)",
        chapters: [
          { text: "Chapter 2: Nouvelle-France" },
          { text: "Chapter 3: Alliances avec les Premières Nations" },
        ],
      },
      {
        text: "Unit C: Régime britannique (1760-1867)",
        chapters: [
          { text: "Chapter 4: Rébellions des Patriotes" },
          { text: "Chapter 5: Acte d'Union" },
        ],
      },
    ],
  },
];

const QuebecSecondary5Subjects = [
  {
    label: "Chimie QC",
    courseCode: "Chimie - Séquence Sciences naturelles (SN)",
    image: QuebecSecondary5Image,
    units: [
      {
        text: "Unit A: Équilibre chimique",
        chapters: [
          { text: "Chapter 1: Constante d'équilibre" },
          { text: "Chapter 2: Principe de Le Chatelier" },
        ],
      },
      {
        text: "Unit B: Électrochimie",
        chapters: [
          { text: "Chapter 3: Piles électrochimiques" },
          { text: "Chapter 4: Électrolyse" },
        ],
      },
      {
        text: "Unit C: Cinétique chimique",
        chapters: [{ text: "Chapter 5: Facteurs influençant les réactions" }],
      },
    ],
  },
  {
    label: "Mathématique QC",
    courseCode: "SN / TS / CST",
    image: QuebecSecondary5Image,
    units: [
      {
        text: "Unit A: SN (Sciences naturelles)",
        chapters: [
          { text: "Chapter 1: Fonctions trigonométriques" },
          { text: "Chapter 2: Logarithmes" },
        ],
      },
      {
        text: "Unit B: TS (Technico-sciences)",
        chapters: [
          { text: "Chapter 3: Statistique inférentielle" },
          { text: "Chapter 4: Optimisation" },
        ],
      },
      {
        text: "Unit C: CST (Culture, société et technique)",
        chapters: [
          { text: "Chapter 5: Mathématiques financières" },
          { text: "Chapter 6: Analyse de sondages" },
        ],
      },
    ],
  },
];

const AlbertaGroupSubjects = [
  {
    label: "Alberta Diploma Examination",
    courseCode: "Alberta",
    image: AlbertaGroupImage,
    units: [
      {
        text: "Alberta: Alberta Diploma Examination",
        chapters: [{ text: "Alberta Diploma Examination", value: "alberta" }],
      },
    ],
  },
  {
    label: "Law – CPLED Bar Admission Program",
    courseCode: "Alberta",
    image: AlbertaGroupImage,
    units: [
      {
        text: "Alberta: Law – CPLED Bar Admission Program",
        chapters: [
          {
            text: "Law – CPLED Bar Admission Program",
            value: "cpled",
          },
        ],
      },
    ],
  },
  {
    label: "Real Estate – RECA Exams",
    courseCode: "Alberta",
    image: AlbertaGroupImage,
    units: [
      {
        text: "Alberta: Real Estate – RECA Exams",
        chapters: [
          {
            text: "Real Estate – RECA Exams",
            value: "reca",
          },
        ],
      },
    ],
  },
  {
    label: "Trades – AIT Exams",
    courseCode: "Alberta",
    image: AlbertaGroupImage,
    units: [
      {
        text: "Alberta: Trades – AIT Exams",
        chapters: [{ text: "Trades – AIT Exams", value: "ait" }],
      },
    ],
  },
];

const BritishColumbiaGroupSubjects = [
  {
    label: "BC Provincial Graduation Assessments",
    courseCode: "British Columbia",
    image: BritishColumbiaGroupImage,
    units: [
      {
        text: "British Columbia: BC Provincial Graduation Assessments",
        chapters: [
          {
            text: "BC Provincial Graduation Assessments",
            value: "bc-provincial",
          },
        ],
      },
    ],
  },
  {
    label: "Bar Admission in British Columbia",
    courseCode: "British Columbia",
    image: BritishColumbiaGroupImage,
    units: [
      {
        text: "British Columbia: Bar Admission in British Columbia",
        chapters: [
          {
            text: "Bar Admission in British Columbia",
            value: "bc-bar",
          },
        ],
      },
    ],
  },
  {
    label: "Real Estate Licensing in BC",
    courseCode: "British Columbia",
    image: BritishColumbiaGroupImage,
    units: [
      {
        text: "British Columbia: Real Estate Licensing in BC",
        chapters: [
          {
            text: "Real Estate Licensing in BC",
            value: "bc-real-estate",
          },
        ],
      },
    ],
  },
];

const OntarioGroupSubjects = [
  {
    label: "OSSLT (Ontario Secondary School Literacy Test)",
    courseCode: "Ontario",
    image: OntarioGroupImage,
    units: [
      {
        text: "Ontario: OSSLT (Ontario Secondary School Literacy Test)",
        chapters: [
          {
            text: "OSSLT (Ontario Secondary School Literacy Test)",
            value: "osslt",
          },
        ],
      },
    ],
  },
  {
    label: "OCT Certification – Ontario College of Teachers exam for teachers",
    courseCode: "Ontario",
    image: OntarioGroupImage,
    units: [
      {
        text: "Ontario: OCT Certification – Ontario College of Teachers exam for teachers",
        chapters: [
          {
            text: "OCT Certification – Ontario College of Teachers exam for teachers",
            value: "oct",
          },
        ],
      },
    ],
  },
  {
    label: "Barrister & Solicitor Exams – Law Society of Ontario.",
    courseCode: "Ontario",
    image: OntarioGroupImage,
    units: [
      {
        text: "Ontario: Barrister & Solicitor Exams – Law Society of Ontario.",
        chapters: [
          {
            text: "Barrister & Solicitor Exams – Law Society of Ontario.",
            value: "ontario-law",
          },
        ],
      },
    ],
  },
  {
    label: "OREA Exams – for real estate agents.",
    courseCode: "Ontario",
    image: OntarioGroupImage,
    units: [
      {
        text: "Ontario: OREA Exams – for real estate agents.",
        chapters: [
          {
            text: "OREA Exams – for real estate agents.",
            value: "orea",
          },
        ],
      },
    ],
  },
  {
    label: "CPA Ontario Exams – for accounting professionals.",
    courseCode: "Ontario",
    image: OntarioGroupImage,
    units: [
      {
        text: "Ontario: CPA Ontario Exams – for accounting professionals.",
        chapters: [
          {
            text: "CPA Ontario Exams – for accounting professionals.",
            value: "cpa-ontario",
          },
        ],
      },
    ],
  },
];

const QuebecGroupSubjects = [
  {
    label: "Épreuves ministérielles (DES).",
    courseCode: "Quebec",
    image: QuebecGroupImage,
    units: [
      {
        text: "Quebec: Épreuves ministérielles (DES).",
        chapters: [
          {
            text: "Épreuves ministérielles (DES).",
            value: "des",
          },
        ],
      },
    ],
  },
  {
    label: "Test de classification en français (TCF).",
    courseCode: "Quebec",
    image: QuebecGroupImage,
    units: [
      {
        text: "Quebec: Test de classification en français (TCF).",
        chapters: [
          {
            text: "Test de classification en français (TCF).",
            value: "tcf",
          },
        ],
      },
    ],
  },
];

const ManitobaGroupSubjects = [
  {
    label: "Grade 12 Provincial Tests",
    courseCode: "Manitoba",
    image: ManitobaGroupImage,
    units: [
      {
        text: "Manitoba: Grade 12 Provincial Tests",
        chapters: [
          {
            text: "Grade 12 Provincial Tests",
            value: "g12pt",
          },
        ],
      },
    ],
  },
];

const NovaScotiaGroupSubjects = [
  {
    label: "Nova Scotia Provincial Examinations.",
    courseCode: "Nova Scotia",
    image: NovaScotiaGroupImage,
    units: [
      {
        text: "Nova Scotia: Nova Scotia Provincial Examinations.",
        chapters: [
          {
            text: "Nova Scotia Provincial Examinations.",
            value: "nspe",
          },
        ],
      },
    ],
  },
];

const SaskatchewanGroupSubjects = [
  {
    label: "Grade 9 Science PAT",
    courseCode: "Saskatchewan",
    image: SaskatchewanGroupImage,
    units: [
      {
        text: "Saskatchewan: Grade 9 Science PAT",
        chapters: [
          {
            text: "Grade 9 Science PAT",
            value: "g9-pat",
          },
        ],
      },
    ],
  },
  {
    label: "Grade 9 Social Studies PAT",
    courseCode: "Saskatchewan",
    image: SaskatchewanGroupImage,
    units: [
      {
        text: "Saskatchewan: Grade 9 Social Studies PAT",
        chapters: [
          {
            text: "Grade 9 Social Studies PAT",
            value: "g9-sspat",
          },
        ],
      },
    ],
  },
];


const NclexRnGroupSubjects = [
  {
    label: "NCLEX-RN",
    courseCode: "nclex-rn",
    image: NclexRnGroupImage,
    units: [
      {
        text: "NCLEX-RN",
        chapters: [
          {
            text: "NCLEX-RN",
            value: "nclex-rn",
          },
        ],
      },
    ],
  },
];


const RexPnGroupSubjects = [
  {
    label: "REx-PN",
    courseCode: "rex-pn",
    image: RexPnGroupImage,
    units: [
      {
        text: "REx-PN",
        chapters: [
          {
            text: "REx-PN",
            value: "rex-pn",
          },
        ],
      },
    ],
  },
];
const PEBCGroupSubjects = [
  {
    label: "PEBC",
    courseCode: "pebc",
    image: PEBCGroupImage,
    units: [
      {
        text: "PEBC",
        chapters: [
          {
            text: "PEBC",
            value: "pebc",
          },
        ],
      },
    ],
  },
];

export const allSubjects = {
  "Ontario Grade 9": OntarioGrade9Subjects,
  "Ontario Grade 10": OntarioGrade10Subjects,
  "Ontario Grade 11": OntarioGrade11Subjects,
  "Ontario Grade 12": OntarioGrade12Subjects,
  "Ontario Career Zone": OntarioGroupSubjects,
  "Alberta Grade 9": AlbertaGrade9Subjects,
  "Alberta Grade 10": AlbertaGrade10Subjects,
  "Alberta Grade 11": AlbertaGrade11Subjects,
  "Alberta Grade 12": AlbertaGrade12Subjects,
  "Alberta Career Zone": AlbertaGroupSubjects,
  "BC Grade 9": BCGrade9Subjects,
  "BC Grade 10": BCGrade10Subjects,
  "BC Grade 11": BCGrade11Subjects,
  "BC Grade 12": BCGrade12Subjects,
  "BC Career Zone": BritishColumbiaGroupSubjects,
  "Quebec Secondary 3": QuebecSecondary3Subjects,
  "Quebec Secondary 4": QuebecSecondary4Subjects,
  "Quebec Secondary 5": QuebecSecondary5Subjects,
  "Quebec Career Zone": QuebecGroupSubjects,
  "Manitoba Career Zone": ManitobaGroupSubjects,
  "Nova Scotia Career Zone": NovaScotiaGroupSubjects,
  "Saskatchewan Career Zone": SaskatchewanGroupSubjects,
  "NCLEX-RN": NclexRnGroupSubjects,
  "REx-PN": RexPnGroupSubjects,
  "PEBC": PEBCGroupSubjects,
};

export const studentsSubjects = {
  "Ontario Grade 9": OntarioGrade9Subjects,
  "Ontario Grade 10": OntarioGrade10Subjects,
  "Ontario Grade 11": OntarioGrade11Subjects,
  "Ontario Grade 12": OntarioGrade12Subjects,
  "Alberta Grade 9": AlbertaGrade9Subjects,
  "Alberta Grade 10": AlbertaGrade10Subjects,
  "Alberta Grade 11": AlbertaGrade11Subjects,
  "Alberta Grade 12": AlbertaGrade12Subjects,
  "BC Grade 9": BCGrade9Subjects,
  "BC Grade 10": BCGrade10Subjects,
  "BC Grade 11": BCGrade11Subjects,
  "BC Grade 12": BCGrade12Subjects,
  "Quebec Secondary 3": QuebecSecondary3Subjects,
  "Quebec Secondary 4": QuebecSecondary4Subjects,
  "Quebec Secondary 5": QuebecSecondary5Subjects,
};

export const careerZoneSubjects = {
  "Ontario Career Zone": OntarioGroupSubjects,
  "Alberta Career Zone": AlbertaGroupSubjects,
  "BC Career Zone": BritishColumbiaGroupSubjects,
  "Quebec Career Zone": QuebecGroupSubjects,
  "Manitoba Career Zone": ManitobaGroupSubjects,
  "Nova Scotia Career Zone": NovaScotiaGroupSubjects,
  "Saskatchewan Career Zone": SaskatchewanGroupSubjects,
  "NCLEX-RN": NclexRnGroupSubjects,
  "REx-PN": RexPnGroupSubjects,
  "PEBC": PEBCGroupSubjects,
};

